import React from "react";
import "./ItemListNotification.css"

type ItemListNotificationProps<T> = {
  item: T
  text: string
  onSelect: (item: T) => void
  className?: string
  //render: (item: T) => React.ReactNode
}

const ItemListNotification = <T,>({
    item,
    text,
    onSelect,
    className
    //render
}: ItemListNotificationProps<T>) => {
    return (
        <div
        className="flex flex-ai-center flex-jc-sb pointer pl-14 pr-14 darks-white-bg option-input-notif"
        onClick={() => onSelect(item)}
        >
        {
            //render(item)
        
        }
        <p className={`fs-11 fw-400 ${className ?? ""}`}>{text}</p>
        </div>
    )
}

export default React.memo(ItemListNotification) as typeof ItemListNotification